import { HTTP } from '@/utils/http';

const rules = {
  accountEmail: {
    getMessage: (field, params, data) => data.message,
    validate(value, args) {
      let valid = true;
      if (value) {
        const pattern = new RegExp(args.domain, 'i');
        valid = value.match(pattern);
      }
      return {
        valid,
        data: {
          message: `Must be an @${args.domain} email address`,
        },
      };
    },
  },
  password: {
    getMessage: field => `The ${field} field must contain at least eight characters, one capital letter, and one number.`,
    validate(value) {
      if (!value) return false;
      if (value.length < 8) return false;
      if (value.match(/[A-Z]/) === null) return false;
      if (value.match(/[0-9]/) === null) return false;
      return true;
    },
  },
  unique: {
    getMessage: (field, params, data) => data.message,
    async validate(value, args) {
      let valid = false;
      try {
        const { data } = await HTTP.get(`/${args.resource}`, { params: { query: value } });
        if (data.record_count === 0) {
          valid = true;
        } else {
          valid = data.data[args.resource][0].id === args.id;
        }
      } catch (error) {
        valid = true;
      }
      return {
        valid,
        data: {
          message: `This ${args.fieldName.replace(/_/, ' ')} is already taken.`,
        },
      };
    },
  },
};

export default (Validator) => {
  Object.keys(rules).forEach(rule => Validator.extend(rule, rules[rule]));
};



// WEBPACK FOOTER //
// ./src/utils/validators.js